var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.selectSummaryText[_vm.shopId])?_c('div',{staticStyle:{"font-size":"13px"}},[_vm._v(_vm._s(_vm.shopName)+"："+_vm._s(_vm.selectSummaryText[_vm.shopId]))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }